/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ClientsInputs */

const en_nav_clients = /** @type {(inputs: Nav_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

const pt_br2_nav_clients = /** @type {(inputs: Nav_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clientes`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Nav_ClientsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_clients = /** @type {((inputs?: Nav_ClientsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ClientsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_clients(inputs)
	return pt_br2_nav_clients(inputs)
});